import Vue from 'vue'
import store from '@/store'
let SolutionDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var solutionDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new SolutionDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  // instance.vm.loadData()
  // 题目的guid
  instance.vm.tmguid = options.tmguid
  // isEditData，新增为false，修改为true
  instance.vm.isEditData = options.isEditData
  // 本解题方法的guid
  instance.vm.guid = options.guid
  instance.vm.show = true
  return instance.vm
}

export default solutionDlg



// WEBPACK FOOTER //
// ./src/components/solutionDlg/src/main.js